import React from 'react';
import { SearchInput } from '@ui/general';
export const SearchFilter = ({ onChange }) => React.createElement(SearchInput, { onChange: (query = '') => onChange({ query }) });
